import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useEditCategoryStyles = makeStyles({
  dialogSurface: {
    maxWidth: "600px",
  },

  dialogContent: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[5],
    paddingTop: designTokens.spacing[2],
    paddingBottom: designTokens.spacing[2],
  },
});
